import { render, staticRenderFns } from "./TicketsTable.vue?vue&type=template&id=3c650dce&scoped=true&"
import script from "./TicketsTable.vue?vue&type=script&lang=js&"
export * from "./TicketsTable.vue?vue&type=script&lang=js&"
import style0 from "./TicketsTable.vue?vue&type=style&index=0&id=3c650dce&prod&lang=sass&scoped=true&"
import style1 from "./TicketsTable.vue?vue&type=style&index=1&id=3c650dce&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c650dce",
  null
  
)

export default component.exports